<template>
  <div id="app_signup">
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <vue-element-loading :active="appLoading1" :is-full-screen="true" />
    <ServerError v-if="ServerError" />

    <v-snackbar v-model="showsnackbar" color="#00a972" right :timeout="timeout">
      {{msg}}
      <v-btn text @click="showsnackbar = false">
        <v-icon style="color:white;">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-layout wrap justify-space-around>
      <v-flex xs12 md12 pa-8>
        <v-card outlined tile>
          <v-layout wrap pt-10>
            <v-flex xs12 md12 text-center>
              <span style="font-size:20px;font-weight:500;">Complete registration details</span>
            </v-flex>
          </v-layout>
          <v-layout wrap px-2 justify-center pt-3>
            <v-flex xs12 md4>
              <v-layout pb-5 wrap justify-center>
                <v-flex xs12 md6 text-center>
                  <span v-if="userType == 'Individual'">Individual Investor</span>
                  <span v-if="userType=='Company'">Company Account</span>
                  <v-progress-linear :value="100" color="#fb6b0b" height="2"></v-progress-linear>
                </v-flex>
                <v-flex xs12 md12 pt-2 text-center>
                  <span style="font-sizer:14px;font-weight:400;color:#a9a9a9">{{userEmail}}</span>
                </v-flex>
              </v-layout>
              <v-layout pb-5 wrap justify-center>
                <v-flex xs12 md5 pt-2 text-center>
                  <v-layout wrap justify-center>
                    <v-flex
                      xs12
                      sm12
                      md12
                      style="height:150px;background-color:#f5f5f5;"
                      align="center"
                      text-center
                    >
                      <v-img
                        v-if="proPicImg"
                        id="proPicImg"
                        :src="proPicImg"
                        aspect-ratio="1"
                        contain
                        height="100%"
                      >
                        <template v-slot:placeholder>
                          <v-row class="fill-height ma-0" align="center" justify="center">
                            <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                      <v-img
                        v-else-if="profilePic"
                        :src="baseURL+'/u/'+profilePic"
                        id="proPic"
                        aspect-ratio="1"
                        contain
                        height="100%"
                      >
                        <template v-slot:placeholder>
                          <v-row class="fill-height ma-0" align="center" justify="center">
                            <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-flex>
                    <v-flex py-2 xs12 sm12 md12>
                      <v-btn
                        rounded
                        small
                        :ripple="false"
                        id="pro_pic"
                        class="text-capitalize"
                        outlined
                        color="#26af82"
                        width="150"
                        @click="$refs.uploadProPicImg.click()"
                      >
                        Profile Picture
                        <v-img
                          src="../../assets/icons/upload.png"
                          aspect-ratio="1"
                          contain
                          height="20px"
                        >
                          <template v-slot:placeholder>
                            <v-row class="fill-height ma-0" align="center" justify="center">
                              <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-btn>
                      <input
                        v-show="false"
                        ref="uploadProPicImg"
                        accept="image/*"
                        type="file"
                        @change="uploadProPicImg"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-text-field
                v-if="userType =='Individual'"
                ref="firstName"
                v-model="firstName"
                :rules="[rules.required,rules.name]"
                label="First Name"
                color="#26af82"
                required
              ></v-text-field>
              <v-text-field
                v-if="userType =='Individual'"
                ref="lastName"
                v-model="lastName"
                :rules="[rules.required,rules.name]"
                label="Last Name"
                color="#26af82"
                required
              ></v-text-field>
              <v-text-field
                v-if="userType =='Company'"
                ref="organization"
                v-model="organization"
                :rules="[rules.required]"
                label="Company Name"
                color="#26af82"
                required
              ></v-text-field>
              <v-text-field
                v-if="userType =='Company'"
                ref="mailId"
                v-model="mailId"
                :rules="[rules.required,rules.email]"
                label="Company Email"
                color="#26af82"
                required
              ></v-text-field>
              <v-text-field
                ref="address"
                v-model="address"
                :rules="[rules.required]"
                label="Address - 1"
                color="#26af82"
                required
              ></v-text-field>
              <v-text-field
                ref="address2"
                v-model="address2"
                :rules="[rules.required]"
                label="Address - 2"
                color="#26af82"
                required
              ></v-text-field>
              <v-text-field ref="address3" v-model="address3" label="Address - 3" color="#26af82"></v-text-field>
              <v-text-field
                ref="city"
                v-model="city"
                :rules="[rules.required]"
                label="City"
                color="#26af82"
                required
              ></v-text-field>
              <v-text-field
                ref="postCode"
                v-model="postCode"
                :rules="[rules.required,rules.postalcode]"
                label="Postcode"
                color="#26af82"
                required
              ></v-text-field>
              <!-- <v-select
                :items="Countries"
                ref="country"
                v-model="country"
                item-text="country"
                item-value="country"
                :rules="[rules.required]"
                label="Country"
                color="#26af82"
              ></v-select>-->
              <v-select
                v-if="userType =='Company'"
                ref="registrationCountry"
                :items="Countries"
                item-text="country"
                item-value="country"
                v-model="registrationCountry"
                :rules="[rules.required]"
                label="Country of Incorporation"
                color="#26af82"
              ></v-select>
            </v-flex>
            <v-flex xs12 md12 py-5 text-center>
              <v-btn
                width="220"
                class="text-capitalize"
                :ripple="false"
                color="#26af82"
                dark
                small
                @click="submit"
              >Submit</v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      firstName: null,
      lastName: null,
      address: null,
      address2: null,
      address3: null,
      street: null,
      city: null,
      postCode: null,
      country: null,
      supDocNo: null,
      formConfirmation: false,

      organization: null,
      mailId: null,
      registrationCountry: null,
      registrationNumber: null,

      accdoc: null,
      Countries: [],
      supportingDocs: [],
      supportingDoc: null,
      winStep: 0,
      rules: {
        required: value => !!value || "Required",
        name: value => {
          const pattern = /^[A-Za-z ]*$/;
          return pattern.test(value) || "Invalid Name";
        },
        postalcode: value => {
          const pattern = /^[0-9]{6}$/;
          return pattern.test(value) || "Invalid Postcode";
        },
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid Mail ID";
        },
        filesize: value =>
          !value ||
          value.size < 5000000 ||
          "Document size should be less than 5 MB!"
      },
      msg: null,
      formHasErrors: true,
      userEmail: localStorage.getItem("email"),
      userType: localStorage.getItem("userType"),

      appLoading: false,
      appLoading1: false,
      showsnackbar: false,
      timeout: 5000,
      ServerError: false,
      proPicImg: null,
      proPic: null,
      proPicSts: false,
      profilePic: null
    };
  },
  computed: {
    form() {
      return {
        firstName: this.firstName,
        lastName: this.lastName,
        address: this.address,
        address2: this.address2,
        city: this.city,
        postCode: this.postCode
        // country: this.country,
      };
    },
    form2() {
      return {
        organization: this.organization,
        mailId: this.mailId,
        address: this.address,
        address2: this.address2,
        city: this.city,
        postCode: this.postCode
        // registrationCountry: this.registrationCountry,
      };
    }
  },
  watch: {
    country: function() {
      if (this.country) {
        axios({
          method: "GET",
          url: "/country/getbyname",
          params: {
            country: this.country
          }
        })
          .then(response => {
            this.supportingDocs = response.data.data.evidence;
          })
          .catch(err => {
            this.msg = err;
            this.ServerError = true;
          });
      }
    }
  },
  beforeMount() {
    this.getCountries();
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading1 = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          if (response.data.progress > 0) {
            this.profilePic = response.data.data.profilepic;
            this.userType = response.data.data.type;
            if (response.data.data.type == "Individual") {
              if (response.data.data.individual.firstName)
                this.firstName = response.data.data.individual.firstName;
              if (response.data.data.individual.lastName)
                this.lastName = response.data.data.individual.lastName;
              if (response.data.data.individual.supportingEvidenceName)
                this.supportingDoc =
                  response.data.data.individual.supportingEvidenceName;
            } else if (response.data.data.type == "Company") {
              this.organization = response.data.data.company.organisation;
              this.registrationCountry =
                response.data.data.company.registrationCountry;
              this.registrationNumber =
                response.data.data.company.registrationNumber;
              this.mailId = response.data.data.company.email;
            }
            if (response.data.data.email)
              this.mailId = response.data.data.email;
            if (response.data.data.address.address)
              this.address = response.data.data.address.address;
            if (response.data.data.address.address2)
              this.address2 = response.data.data.address.address2;
            if (response.data.data.address.address3)
              this.address3 = response.data.data.address.address3;
            if (response.data.data.address.city)
              this.city = response.data.data.address.city;
            if (response.data.data.address.postcode)
              this.postCode = response.data.data.address.postcode;
            if (response.data.data.address.country)
              this.country = response.data.data.address.country;
          }
          this.appLoading1 = false;
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    },
    getCountries() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/country/getlist"
      })
        .then(response => {
          this.appLoading = false;
          this.Countries = response.data.data;
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    },
    uploadProPicImg(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      if (files[0].size > 5097152) {
        this.msg = "File Should be less than 2MB";
        this.showsnackbar = true;
        return;
      }
      this.proPic = e.target.files[0];
      var reader = new FileReader();
      reader.onload = e => {
        this.proPicImg = e.target.result;
      };
      this.proPicSts = true;
      reader.readAsDataURL(files[0]);
    },
    submit() {
      this.formHasErrors = false;
      if (this.proPicSts == false && this.profilePic == "user.png") {
        this.formHasErrors = true;
        this.msg = "Upload Profile Picture";
        this.showsnackbar = true;
        return;
      }
      if (this.userType == "Individual") {
        Object.keys(this.form).forEach(f => {
          if (!this.form[f]) this.formHasErrors = true;
          if (!this.$refs[f].validate(true)) this.formHasErrors = true;
        });
      }
      if (this.userType == "Company") {
        Object.keys(this.form2).forEach(f => {
          if (!this.form2[f]) this.formHasErrors = true;
          if (!this.$refs[f].validate(true)) this.formHasErrors = true;
        });
      }
      this.appRegister();
    },
    appRegister() {
      if (!this.formHasErrors) {
        var prodata = {};
        prodata["id"] = localStorage.getItem("userId");
        prodata["address"] = this.address;
        prodata["address2"] = this.address2;
        prodata["address3"] = this.address3;
        prodata["city"] = this.city;
        prodata["postcode"] = this.postCode;
        // prodata["country"] = this.country;
        if (this.userType == "Individual") {
          prodata["firstName"] = this.firstName;
          prodata["lastName"] = this.lastName;
          prodata["isAccreditated"] = true;
        }
        if (this.userType == "Company") {
          prodata["isAccreditated"] = false;
          prodata["organisation"] = this.organization;
          prodata["companyemail"] = this.mailId;
          prodata["registrationCountry"] = this.registrationCountry;
          prodata["registrationNumber"] = this.registrationNumber;
        }
        this.appLoading = true;
        axios({
          method: "POST",
          url: "/user/Edit",
          headers: {
            "x-auth-token": localStorage.getItem("token")
          },
          data: prodata
        })
          .then(response => {
            this.appLoading = false;
            if (response.data.status) {
              this.uploadProPic();
            } else {
              this.msg = response.data.msg;
              this.appLoading = false;
            }
          })
          .catch(err => {
            this.msg = err;
            this.ServerError = true;
          });
      } else {
        this.msg = "Please Validate Input";
        this.showsnackbar = true;
        this.appLoading = false;
      }
    },
    uploadProPic() {
      if (this.proPic) {
        this.appLoading = true;
        var formData = null;
        formData = new FormData();
        formData.append("photo", this.proPic);
        axios({
          method: "POST",
          url: "/user/profilepic",
          headers: {
            "Content-Type": "multipart/form-data",
            "x-auth-token": localStorage.getItem("token")
          },
          data: formData
        })
          .then(response => {
            this.appLoading = false;
            this.$router.push("/DocumentsUpload");
            this.msg = response.data.msg;
            this.showsnackbar = true;
          })
          .catch(err => {
            this.msg = err;
            this.ServerError = true;
          });
      } else {
        // this.uploadCheck();
        this.$router.push("/DocumentsUpload");
      }
    }
  }
};
</script>
<style scoped>
#app_signup {
  background-image: url("../../assets/home_header.png");
  background-repeat: no-repeat;
  background-size: contain;
  color: white;
}
.confbox >>> label {
  color: black !important;
  font-size: 11px !important;
  line-height: 12px !important;
}
.upload-btn-wrapper {
  position: relative;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
</style>